import { NavLink } from "react-router";
import { motion } from "framer-motion";

export default function Unauthorized(): JSX.Element {
  return (
    <div className="flex flex-col items-center justify-center min-h-[85vh] bg-gray-50 text-center px-6">
      <motion.h1
        className="text-8xl font-extrabold text-indigo-600 mb-4"
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        401
      </motion.h1>

      <motion.h2
        className="text-3xl font-bold text-gray-900 mb-3"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.3, duration: 0.8 }}
      >
        Unauthorized Access
      </motion.h2>

      <motion.p
        className="text-gray-600 mb-8 max-w-md"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.6, duration: 0.8 }}
      >
        You don’t have permission to view this page.  
        Please log in again or return to the homepage.
      </motion.p>

      <motion.div
        className="flex flex-wrap justify-center gap-4"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 1, duration: 0.7 }}
      >
        <NavLink
          to="/login"
          className="rounded-xl bg-indigo-600 px-6 py-3 text-white font-semibold shadow-md hover:bg-indigo-700"
        >
          Login Again
        </NavLink>
        <NavLink
          to="/"
          className="rounded-xl bg-white px-6 py-3 text-indigo-600 font-semibold shadow-md hover:bg-indigo-50"
        >
          Go Home
        </NavLink>
      </motion.div>

      <motion.img
        src="/images/401-unauthorized.svg"
        alt="Unauthorized illustration"
        className="mt-10 w-full max-w-md mx-auto"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.2, duration: 0.8 }}
      />
    </div>
  );
}
